import { type SerializedCompStructure } from '@wix/document-services-types'

import { type ComponentConnectionList } from '../types'

export function assertConnectionList(
  connections: NonNullable<SerializedCompStructure['connections']>,
): asserts connections is ComponentConnectionList {
  if (connections.type !== 'ConnectionList') {
    throw new Error('The component connections are not a connection list.')
  }
}
